import { render } from "./help-screen.html?vue&type=template&id=46416d1c&scoped=true&ts=true&external"
import script from "./help-screen.ts?vue&type=script&lang=ts&external"
export * from "./help-screen.ts?vue&type=script&lang=ts&external"

import "./help-screen.scss?vue&type=style&index=0&id=46416d1c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46416d1c"]])

export default __exports__